import React from 'react';
import './index.less';
import PropTypes from 'prop-types';
import wrapReact from '../../util/react';

export const Page404 = wrapReact(props => (
  <div className={`${props.filePath} ${props.className}`}>
    <p className="e404">404</p>
    <p className="error">ERROR</p>
    <p className="notFound">PAGE NOT FOUND</p>
  </div>
),
'page_404');

Page404.propTypes = {
  filePath: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
};

export default Page404;
